import Component from './component';
import iconDownload from '../assets/icons/download.svg';

export default class Download extends Component {
  render () {
    return `
      <button class="iono-button iono-player-download iono-theme-button" title="${this.props.locale.player.download}">
        <span class="iono-icon iono-button-icon" aria-hidden="true">${iconDownload}</span>
        <span class="iono-button-label iono-sr-only">${this.props.locale.player.download}</span>
      </button>
    `;
  }

  handleEvent (event) {
    if (event.type === 'click' || event.type === 'levelchange') {
      this.props.player.download();
    }
  }

  attach (element) {
    super.attach(element);
    this.$element.addEventListener('click', this);
  }

  detach () {
    if (this.isAttached()) {
      this.$element.removeEventListener('click', this);
    }
    super.detach();
  }
}
